export default class ImageComparison {
  constructor(options) {
    this.$el = options.$el;
    this.setEvents();
  }

  setEvents() {
    const button = this.$el.querySelector("input[type=checkbox]");
    const beforeImage = this.$el.querySelector(".slide__image--before");
    const afterImage = this.$el.querySelector(".slide__image--after");

    button.addEventListener("change", () => {
      afterImage.classList.toggle("status");
      beforeImage.classList.toggle("status");
    });
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/ImageComparison.js